mutation createHoppermationSender($input: CreateHoppermationSenderInput!) {
  sender: createHoppermationSender(input: $input) {
    id
    isVerified
    isAcknowledged
    fromEmail
    name
  }
}
